export const ANSWER_REQUESTING = '[ANSWER LIST] ANSWER_REQUESTING';
export const ANSWER_REQUEST_SUCCESS = '[ANSWER LIST] ANSWER_REQUEST_SUCCESS';
export const ANSWER_REQUEST_FAILED = '[ANSWER LIST] ANSWER_REQUEST_FAILED';

export const ANSWER_DETAIL_REQUESTING = '[ANSWER DETAIL] ANSWER_DETAIL_REQUESTING';
export const ANSWER_DETAIL_REQUEST_SUCCESS = '[ANSWER DETAIL] ANSWER_DETAIL_REQUEST_SUCCESS';
export const ANSWER_DETAIL_REQUEST_FAILED = '[ANSWER DETAIL] ANSWER_DETAIL_REQUEST_FAILED';
